module.exports = __webpack_public_path__ + "static/media/lunbo2.d1938cff.png";